var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fw-loader",class:_vm.isMobile ? 'mob' : 'desk'})
}
var staticRenderFns = []

export { render, staticRenderFns }